/**
 * @generated SignedSource<<fc597116443bcfe1b601af31508a0053>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type PodcastSourceTypeV2 = "none" | "podigee" | "vimeo" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PodigeePodcastElementForm_PodcastElementV2Fragment$data = {
  readonly id: string;
  readonly podcastSource: {
    readonly lengthInSeconds?: number;
    readonly podigeeUrl?: string;
    readonly sourceType: PodcastSourceTypeV2;
  };
  readonly title: string;
  readonly " $fragmentType": "PodigeePodcastElementForm_PodcastElementV2Fragment";
};
export type PodigeePodcastElementForm_PodcastElementV2Fragment$key = {
  readonly " $data"?: PodigeePodcastElementForm_PodcastElementV2Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PodigeePodcastElementForm_PodcastElementV2Fragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PodigeePodcastElementForm_PodcastElementV2Fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "podcastSource",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sourceType",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lengthInSeconds",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "podigeeUrl",
              "storageKey": null
            }
          ],
          "type": "PodigeePodcastSourceV2",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PodcastElementV2",
  "abstractKey": null
};

(node as any).hash = "497781356159acfce5f7b18abf80d7e3";

export default node;
